<template>
  <section class="properties-section">
    <div class="container">
      <h2><span>Imóveis</span> em destaque</h2>
      <router-link :to="{ name: 'PropertiesList' }" class="view-more" exact>
        Ver todos
        <img alt="Icon arrow left" src="~@/assets/icons/arrow-left.svg" />
      </router-link>
    </div>
    <div class="container container-properties">
      <div
        class="box-properties"
        v-for="item in highlightedProperties"
        :value="item.id"
        :key="item.id"
      >
        <router-link
          :to="{
            name: 'Properties',
            params: { slug: item.attributes.slug, id: item.id }
          }"
          exact
        >
          <img class="properties-image" alt="" :src="item.attributes.banner" />
          <div class="properties-content">
            <p class="tag">
              {{ item.attributes.building_status.name }}
            </p>
            <div>
              <router-link
                :to="{
                  name: 'Properties',
                  params: { slug: item.attributes.slug, id: item.id }
                }"
                exact
              >
                <img class="logo" alt="" :src="item.attributes.logo" />
              </router-link>

              <router-link
                :to="{
                  name: 'Properties',
                  params: { slug: item.attributes.slug, id: item.id }
                }"
                exact
              >
                <h3>{{ item.attributes.name }}</h3>
              </router-link>

              <router-link
                :to="{
                  name: 'Properties',
                  params: { slug: item.attributes.slug, id: item.id }
                }"
                exact
              >
                <p class="locale">{{ item.attributes.city.name }}</p>
              </router-link>

              <p class="infos">
                {{ buildingDetail(item.attributes) }}
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { buildingsService } from "@/services/buildings.service";

export default {
  name: "PropertiesSection",
  data() {
    return {
      properties: []
    };
  },

  mounted() {
    this.getProperties();
  },

computed: {
  highlightedProperties() {
    return this.properties.filter(
      (item) => item.attributes.highlighted === true
    );
  }
},

  methods: {
    buildingDetail(property) {
      let detail = [];

      if (property.area && property.area !== "null") {
        detail.push(`${property.area}m²`);
      }

      if (property.bedrooms && property.area !== "null") {
        let roomLabel = property.bedrooms === 1 ? "quarto" : "quartos";
        detail.push(`${property.bedrooms} ${roomLabel}`);
      }

      if (!detail.length) {
        detail.push("Não informado");
      }

      return detail.join(" - ");
    },

    async getProperties() {
      try {
        const params = {
          is_visible: true,
          items: 4,
          page: 1
        };
        const properties = await buildingsService.listBuildings(params);
        this.properties = properties.data.data.slice(0, 4);
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.properties-section {
  padding: 85px 0 140px;

  .container {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    align-items: center;

    &.container-properties {
      max-width: 1200px;
      margin-top: 62px;
    }
  }

  a {
    text-decoration: none;
    width: 100%;
  }

  h2 {
    font-size: var(--size-h2);
    line-height: 48px;
    color: var(--secundary-black);
    font-weight: 700;

    span {
      font-weight: 400;
      line-height: 32px;
      font-weight: 300;
      color: var(--blue-custom);
    }
  }

  .view-more {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    color: var(--blue-custom);
    font-size: var(--size-h4);
    text-decoration: none;
    max-width: 160px;

    img {
      margin-left: 16px;
    }
  }

  .box-properties {
    position: relative;
    min-height: 371px;
    display: flex;
    max-width: 312px;
    width: 100%;
    margin: 0 10px 0 10px;

    .properties-image {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 20px;
      height: 230px;
      width: 100%;
      object-fit: cover;
    }

    .properties-content {
      position: relative;
      z-index: 5;
      display: flex;
      height: 376px;
      width: 100%;
      flex-direction: column;
      justify-content: space-between;
      padding: 24px 16px 16px;
      border-radius: 20px;

      .tag {
        background: rgba(183, 145, 105, 1);
        color: var(--white);
        font-size: var(--size-tag);
        display: flex;
        align-items: center;
        height: 25px;
        max-width: 117px;
        padding: 1px 0 0;
        border-radius: 39px;
        justify-content: center;
        font-weight: 700;
      }

      a {
        text-decoration: none;
      }

      .logo {
        width: 66px;
        height: auto;
        margin-bottom: 12px;
        background-color: var(--white);
        border-radius: 10px;
      }

      h3 {
        font-weight: 700;
        line-height: 24px;
        color: var(--blue-custom);
        font-size: var(--size-large);
        margin-bottom: 4px;
        min-height: 48px;
      }

      .locale {
        max-width: 218px;
        font-weight: 400;
        color: var(--blue-custom);
        line-height: 19px;
        font-size: var(--size-button);
        margin-bottom: 16px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .infos {
        font-weight: 400;
        color: var(--yellow-custom);
        line-height: 14px;
        font-size: var(--size-small);
        text-transform: uppercase;
        display: inline-block;
        margin-right: 16px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          right: -10px;
          top: 4px;
          background: var(--yellow-custom);
          width: 5px;
          height: 5px;
          border-radius: 100px;
        }
        &:last-child {
          margin-right: 0px;

          &::after {
            display: none;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 80px 0 45px;

    .container {
      align-items: flex-start;
      flex-direction: column;

      &.container-properties {
        flex: 1;
        flex-wrap: wrap;
        align-items: center;
        flex-direction: row;
        margin-top: 32px;
      }
    }

    .box-properties {
      min-height: inherit;
      margin-bottom: 20px;
      .properties-image {
        width: 100%;
      }
    }
  }

  @media (max-width: 350px) {
    .container.container-properties {
      .box-properties {
        .properties-content {
          width: 100%;
          height: 345px;
        }
        .properties-image {
          height: 200px;
        }
      }
    }
  }
}
</style>
